import * as React from "react";
import { CloseIcon, CloseIconContainer } from "./styles";
import { useIsMobile } from "../../../../hooks/useIsMobile.hook";
import { useModalForm } from "./hooks/useModalForm.hook";
import { Close as CloseOutlined, UIButton, UIForm, UIInput, UIModal } from "ui";

interface SubmitFormModalProps {
    isSubmitModalOpen: boolean;
    toggleModal: VoidFunction;
}

export const SubmitFormModal = ({ isSubmitModalOpen, toggleModal }: SubmitFormModalProps) => {
    const isMobile = useIsMobile();
    const { handleSubmit, formData, handleChange } = useModalForm();

    return (
        <UIModal
            open={isSubmitModalOpen}
            onClose={toggleModal}
            className="products__modal"
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            width={isMobile ? "90%" : "50%"}
            centered
            destroyOnClose
            closable={false}
        >
            <div style={{ maxHeight: "90vh", overflowY: "auto", position: "relative" }}>
                <CloseIconContainer onClick={toggleModal}>
                    <CloseIcon>
                        <CloseOutlined />
                    </CloseIcon>
                </CloseIconContainer>
                <UIForm
                    sx={{
                        paddingLeft: isMobile ? 16 : 32,
                        paddingRight: isMobile ? 16 : 32,
                        paddingBottom: isMobile ? 24 : 32,
                    }}
                    onSubmit={handleSubmit}
                >
                    <UIInput
                        required
                        fullWidth
                        label="Company name"
                        name="сompany_name"
                        margin="normal"
                        variant="outlined"
                        value={formData.company_name}
                        onChange={handleChange}
                        sx={{ borderRadius: 2, backgroundColor: "#fff" }}
                    />
                    <UIInput
                        required
                        fullWidth
                        label="Email"
                        name="email"
                        margin="normal"
                        variant="outlined"
                        value={formData.email}
                        onChange={handleChange}
                        sx={{ borderRadius: 2, backgroundColor: "#fff" }}
                    />
                    <UIInput
                        required
                        fullWidth
                        label="Phone number"
                        name="email"
                        margin="normal"
                        variant="outlined"
                        value={formData.phone}
                        onChange={handleChange}
                        sx={{ borderRadius: 2, backgroundColor: "#fff" }}
                    />
                    <UIInput
                        required
                        fullWidth
                        label="Phone number"
                        name="email"
                        margin="normal"
                        variant="outlined"
                        value={formData.brands}
                        onChange={handleChange}
                        sx={{ borderRadius: 2, backgroundColor: "#fff" }}
                    />
                    <div style={{ marginTop: 16, marginBottom: 16 }} />
                    <UIButton
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            marginTop: 8,
                            paddingTop: 12,
                            paddingBottom: 12,
                            fontWeight: 500,
                            backgroundColor: "#006AFF",
                            borderRadius: 8,
                        }}
                    >
                        Submit
                    </UIButton>
                </UIForm>
            </div>
        </UIModal>
    )

}
